module.exports = __webpack_public_path__ + "img/logo-reporting.5e3c2d03.png";